import React from 'react';
import { ShieldCheckIcon, LinkIcon, LockIcon, StethoscopeIcon } from 'lucide-react';
import { FadeInSection } from './ui/FadeInSection';
export function TrustBar() {
  const trustItems = [{
    icon: ShieldCheckIcon,
    text: 'End-to-End Encrypted'
  }, {
    icon: LinkIcon,
    text: 'Verified Coverage Data'
  }, {
    icon: LockIcon,
    text: 'HIPAA Compliant'
  }, {
    icon: StethoscopeIcon,
    text: 'Multi-Specialty Support'
  }];
  return <section className="bg-white border-y border-gray-100 py-8" data-id="element-432">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-433">
        <FadeInSection data-id="element-434">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 items-start justify-center" data-id="element-435">
            {trustItems.map((item, index) => <div key={index} className="flex flex-col items-center text-center space-y-3" data-id="element-436">
                <div className="h-12 w-12 rounded-full bg-brand-lightGray flex items-center justify-center text-brand-green" data-id="element-437">
                  <item.icon className="h-6 w-6" data-id="element-438" />
                </div>
                <p className="text-sm font-medium text-brand-bodyText max-w-[140px]" data-id="element-439">
                  {item.text}
                </p>
              </div>)}
          </div>
        </FadeInSection>
      </div>
    </section>;
}